import { validateEmailField } from '../../../Core/Helpers/emailValidation';

export default (values) => {

  const warnings = {}

  // Real-time validation for email fields (shows warnings as user types)
  if (values.to) {
    const toWarning = validateEmailField(values.to);
    if (toWarning) warnings.to = toWarning;
  }

  if (values.cc) {
    const ccWarning = validateEmailField(values.cc);
    if (ccWarning) warnings.cc = ccWarning;
  }

  if (values.bcc) {
    const bccWarning = validateEmailField(values.bcc);
    if (bccWarning) warnings.bcc = bccWarning;
  }

  return warnings;

}
